import {
    crudSlice, failReducer, loadingReducer, readAllSuccess, deleteSuccess
} from 'saga-slice-helpers';
import { sagaApi } from '#/apis';
import { takeLatest } from 'redux-saga/effects';
import Swal from '#/swal';

const sagaSliceModule = crudSlice({
    name: 'properties',
    reducers: {
        readAllGroupings: loadingReducer,
        readAllGroupingsSuccess: readAllSuccess,

        deleteGrouping: loadingReducer,
        deleteGroupingSuccess: deleteSuccess,

        upsertGrouping: loadingReducer,

        failReducer
    },
    sagaApi,
    takers: { readAll: takeLatest },
    sagas: A => ({
        [A.deleteGrouping]: function*({ payload: id }){
            yield sagaApi.delete(`/unit-type-groupings/${id}`, null, A.deleteGroupingSuccess, A.failReducer);
        },
        [A.deleteSuccess]: function* (){
            yield Swal.fire.success();
        },
        [A.readAllGroupings]: function*({ payload: type }) {
            yield sagaApi.get(`/unit-type-groupings/${type}`, A.readAllGroupingsSuccess, A.failReducer);
        },
        [A.upsertGrouping]: function*({ payload }) {
            yield sagaApi.post('/unit-type-groupings', payload, A.readAllGroupings, A.failReducer);
        }
    })
});

export const { actions } = sagaSliceModule;
export default sagaSliceModule;
